// Small pure helpers shared between LocationDashboard and LocationRow.
// Kept module-level (not inside a component) so they are never recreated on render.

export const hasCoords = (employee) =>
  employee.latitude !== null && employee.longitude !== null;

export const getLocationStatus = (employee) => {
  if (employee.status === 'offline') {
    return { text: 'Offline', className: 'status-offline' };
  }

  if (employee.permissionStatus === 'denied' || employee.permissionStatus === 'blocked') {
    return { text: 'Permission Denied', className: 'status-denied' };
  }

  if (employee.locationEnabled) {
    return { text: 'Live', className: 'status-live' };
  }

  return { text: 'Unknown', className: 'status-unknown' };
};

export const formatLastUpdated = (lastUpdated) => {
  if (!lastUpdated) return 'Never';

  const date = new Date(lastUpdated);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} min ago`;

  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;

  return date.toLocaleString();
};

export const canViewEmployeeLocation = (employee) =>
  employee.locationEnabled &&
  hasCoords(employee) &&
  employee.permissionStatus !== 'denied' &&
  employee.permissionStatus !== 'blocked';
